<template>
  <aw-cms-page v-if="contentData" :content-data="contentData" :class="$style.page" />
</template>

<script setup lang="ts">
  import { computed, defineAsyncComponent, onBeforeUnmount, onMounted } from 'vue';
  import { useNuxtApp } from 'nuxt/app';
  import { useJsonld } from '#jsonld';
  import { useContentsStore } from '~~/common/stores/contents';
  import { useUserInterfaceStore } from '~~/common/stores/userInterface';

  const AwCmsPage = defineAsyncComponent(() => import('~~/common/components/Page/Content/AwCmsPage.vue'));

  defineOptions({
    name: 'IndexPage',
  });
  // eslint-disable-next-line no-undef
  definePageMeta({
    layout: 'full-width',
  });

  const STATIC_CONTENT_TYPE = 'dh_homepage';

  const contentsStore = useContentsStore();
  const userInterfaceStore = useUserInterfaceStore();
  const { $awRuntimeConfig } = useNuxtApp();

  useJsonld(() => {
    const browserHost = $awRuntimeConfig.auchanApiBrowserHost;
    return {
      '@context': 'https://schema.org',
      '@type': 'WebSite',
      url: browserHost,
      potentialAction: {
        '@type': 'SearchAction',
        target: {
          '@type': 'EntryPoint',
          urlTemplate: browserHost + '/shop/search?q%5B%5D={search_term_string}',
        },
        'query-input': 'required name=search_term_string',
      },
    };
  });

  const contentData = computed(() => contentsStore.staticContent[STATIC_CONTENT_TYPE]);

  onMounted(() => {
    contentsStore.increaseStaticContentUsers({ type: STATIC_CONTENT_TYPE });
    if (contentData.value) {
      userInterfaceStore.setBackground({ ...contentData.value });
    }
  });
  onBeforeUnmount(() => {
    contentsStore.decreaseStaticContentUsers({ type: STATIC_CONTENT_TYPE });
  });
</script>

<style module lang="scss" rel="stylesheet/scss">
.page {
  padding-bottom: 20px;

  @include tablet(min) {
    padding-bottom: 40px;
  }
}
</style>
